//TODO (more like a warning...): Notice: leaflet.heat relies on the global 'L' reference declared by leaflet.
// If you 'import L from "leaflet";' in other components, the compilation process will, for reasons beyond me, rename this 'L' reference to 'L<somenumber>'.
// Which will cause at least leaflet.heat to stop working.
// This is the reason all the MapLayer implementations exist in this same file; to make sure we only have one import of leaflet.
// Its feasible this setup can be generified in such a way that we CAN extract the MapLayer implementations.
// The MapContainerComponent would need to apply operations provided by each layer or something.

import {Component, effect, inject, Injectable, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";

import L from "leaflet";
import 'leaflet.heat';
import 'leaflet.markercluster';
import {isValidGpsFixSample} from "src/app/presentation/main-view/map-container/map-utils";
import {
  AnimalMarkerComponent
} from "src/app/presentation/main-view/map-container/layers/animal-marker/animal-marker.component";
import {
  GatewayMarkerComponent
} from "src/app/presentation/main-view/map-container/layers/gateway-marker/gateway-marker.component";
import {
  PrecipitationPointMarkerComponent
} from "src/app/presentation/main-view/map-container/layers/precipitation-point-marker/precipitation-point-marker.component";
import {
  WaterLevelMarkerComponent
} from "src/app/presentation/main-view/map-container/layers/water-level-marker/water-level-marker.component";
import {ToGatewayIconPipe} from "src/app/presentation/common/pipes/ToGatewayIconPipe";
import {ToWaterPointIconPipe} from "src/app/presentation/common/pipes/ToWaterPointIconPipe";

import {
  oneHour,
  sevenDays,
  sixtyDays,
  thirtyDays,
  threeDays,
  twentyFourHours
} from "src/app/presentation/common/globals";
import {
  ProximityPointMarkerComponent
} from "src/app/presentation/main-view/map-container/layers/proximity-point-marker/proximity-point-marker.component";

import {
  LocatorMarkerComponent
} from "src/app/presentation/main-view/map-container/layers/locator-marker/locator-marker.component";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {
  Animal,
  AnimalType,
  Asset,
  FixedSamplePoint,
  LoRaGateway,
  LoRaGatewayStatus,
  Paddock,
  PaddockGeometry,
  simplify,
  WaterPoint
} from "src/app/infrastructure/moovement-api/models/asset";
import {Subject, takeUntil} from "rxjs";
import {UserLocationStore} from 'src/app/domain/user/user-location.store';
import {
  UserLocationMarkerComponent
} from 'src/app/presentation/main-view/map-container/user/user-location-marker.component';
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';
import {AnimalsStore} from 'src/app/domain/assets/animals/animals.store';
import {AggregatedAssetStateStore} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state.store';
import {EntityMap} from '@ngrx/signals/entities';
import {AggregatedAssetState} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state';
import {LocationAgeFilterPeriod, MapStore} from 'src/app/domain/map/map.store';
import {Router} from '@angular/router';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {GatewayStore} from 'src/app/domain/devices/gateway/gateway.store';
import {GatewayStatusStore} from 'src/app/domain/devices/gateway/gateway-status.store';
import {Status} from 'src/app/presentation/common/icons/bluetooth-svg/bluetooth-svg.component';
import {Location} from 'src/app/domain/samples/rssi/location';
import {
  SignalStrengthAnalysisStore
} from 'src/app/presentation/main-view/signal-strength-analysis/signal-strength-analysis.store';
import {unassignedAnimalsPaddock} from 'src/app/domain/assets/paddocks/unassigned-animals-paddock';
import {PaddockStore} from 'src/app/domain/assets/paddocks/paddock.store';
import {rssisToRgb} from 'src/app/domain/samples/rssi/rssi';
import {areaWithUnit} from 'src/app/domain/util/units/units';
import {isEqualToOrYoungerThanOffset} from 'src/app/app.config';
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';
import {WaterPointsStore} from 'src/app/domain/assets/water-points/water-points.store';
import {
  HistoricalLocation,
  HistoricalLocationStore
} from 'src/app/domain/samples/historical-location/historical-location.store';
import {AggregatedDeviceState} from "src/app/domain/devices/aggregated-state/aggregated-device-state";
import {AggregatedDeviceStateStore} from "src/app/domain/devices/aggregated-state/aggregated-device-state.store";
import {DeviceAssociationStore} from "src/app/domain/devices/device-association.store";
import {DeviceType} from "src/app/domain/devices/device";
import {DeviceStore} from "src/app/domain/devices/device.store";

const baseZoom = 12;
const maxZoom = 21;
const minZoom = 3;

export const defaultmaxNativeZoom = 18;

const openStreetMaps = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
  maxZoom: maxZoom,
  minZoom: minZoom,
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
})

const arcGisMaps = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
  maxZoom: maxZoom,
  maxNativeZoom: defaultmaxNativeZoom,
  minZoom: minZoom
})
let mapContainer: L.Map | undefined

@Component({
  selector: 'app-map-container',
  templateUrl: './map-container-component.html',
  imports: [],
  styleUrl: './map-container-component.css'
})
export class MapContainerComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();

  private readonly aggregatedAssetStateStore = inject(AggregatedAssetStateStore);
  private readonly animalsStore = inject(AnimalsStore);
  private readonly farmStore = inject(FarmStore);
  private readonly fixedSamplePointsStore = inject(FixedSamplePointsStore);
  private readonly gatewayStore = inject(GatewayStore);
  private readonly gatewayStatusStore = inject(GatewayStatusStore);
  private readonly historicalLocationStore = inject(HistoricalLocationStore);
  private readonly mapStore = inject(MapStore);
  private readonly paddockStore = inject(PaddockStore);
  private readonly userLocationStore = inject(UserLocationStore);
  private readonly waterPointStore = inject(WaterPointsStore);
  private readonly waterPointLayerGroup = L.layerGroup();
  private readonly animalLayerGroup = L.layerGroup();
  private readonly historicAnimalLayerGroup = L.layerGroup();
  private readonly gatewayLayerGroup = L.layerGroup();
  private readonly proximitySamplePointLayerGroup = L.layerGroup();
  private readonly grazingPatternLayerGroup = L.layerGroup();
  private readonly signalStrengthAnalysisLayerGroup = L.layerGroup();
  private readonly paddockLayerGroup = L.layerGroup();
  private readonly precipitationSamplePointLayerGroup = L.layerGroup();
  private readonly signalStrengthAnalysisLegend = new SignalStrengthAnalysisLegend({ position: 'bottomright' });

  private readonly userMarker;

  private signalStrengthAnalysisStore = inject(SignalStrengthAnalysisStore);
  private waterPointLayer = inject(WaterPointLayer);
  private animalLayer = inject(AnimalLayer);
  private dropAPinLayer = inject(DropAPinLayer);
  private historicAnimalLayer = inject(HistoricAnimalLocationLayer);
  private gatewayLayer = inject(GatewayLayer);
  private proximitySamplePointLayer = inject(ProximitySamplePointLayer);
  private grazingPatternLayer = inject(GrazingPatternLayer);
  private signalStrenghtAnalysisLayer = inject(SignalStrengthAnalysisLayer);
  private paddockLayer = inject(PaddockLayer);
  private precipitationSamplePointLayer = inject(PrecipitationSamplePointLayer);
  private viewRef = inject(ViewContainerRef);
  private mapStateService = inject(MapStateService);
  protected viewportService = inject(ViewportService);
  protected dataSubscriptionService = inject(DataSubscriptionService);

  constructor() {
    this.waterPointLayer.setLayerGroup(this.waterPointLayerGroup);
    this.animalLayer.setLayerGroup(this.animalLayerGroup);
    this.historicAnimalLayer.setLayerGroup(this.historicAnimalLayerGroup);
    this.gatewayLayer.setLayerGroup(this.gatewayLayerGroup);
    this.proximitySamplePointLayer.setLayerGroup(this.proximitySamplePointLayerGroup);
    this.grazingPatternLayer.setLayerGroup(this.grazingPatternLayerGroup);
    this.signalStrenghtAnalysisLayer.setLayerGroup(this.signalStrengthAnalysisLayerGroup);
    this.paddockLayer.setLayerGroup(this.paddockLayerGroup);
    this.precipitationSamplePointLayer.setLayerGroup(this.precipitationSamplePointLayerGroup);

    this.userMarker = this.createUserMarker(this.viewRef);

    effect(() => {
      if (this.userLocationStore.latitude() && this.userLocationStore.longitude()) {
        const latLng = new L.LatLng(this.userLocationStore.latitude()!, this.userLocationStore.longitude()!, 0.5);
        this.userMarker.setLatLng(latLng);
        this.userMarker.setOpacity(1);
      }
    });

    effect(() => {
      this.animalLayer.setData(
        this.animalsStore.entities(),
        this.aggregatedAssetStateStore.entityMap(),
        this.mapStore.locationAgeFilterPeriod(),
      );
      this.animalLayer.render(this.viewRef);
    });

    effect(() => {
      this.gatewayLayer.setGateways(this.gatewayStore.entities());
      this.gatewayLayer.setStatuses(this.gatewayStatusStore.entityMap());
      this.gatewayLayer.render(this.viewRef);
    });

    effect(() => {
        if (this.aggregatedAssetStateStore.loading() || this.fixedSamplePointsStore.loading()) return;

        this.proximitySamplePointLayer.setProximitySamplePoints(this.fixedSamplePointsStore.proximitySamplePoints());
        this.proximitySamplePointLayer.setAggregatedAssetStates(this.aggregatedAssetStateStore.entityMap());
        this.proximitySamplePointLayer.render(this.viewRef);
    });

    effect(() => {
      if (this.mapStore.animalLocationLayer()) {
        mapContainer?.addLayer(this.animalLayerGroup);
      } else {
        this.animalLayerGroup.remove();
      }
    });

    effect(() => {
      if (this.mapStore.gatewayLayer()) {
        mapContainer?.addLayer(this.gatewayLayerGroup);
      } else {
        this.gatewayLayerGroup.remove();
      }
    });

    effect(() => {
      if (this.mapStore.grazingPatternLayer()) {
        mapContainer?.addLayer(this.grazingPatternLayerGroup);
      } else {
        this.grazingPatternLayerGroup.remove();
      }
    });

    effect(() => {
      if (this.mapStore.signalStrengthAnalysisLayer()) {
        mapContainer?.addLayer(this.signalStrengthAnalysisLayerGroup);
        mapContainer?.addControl(this.signalStrengthAnalysisLegend);
      } else {
        this.signalStrengthAnalysisLayerGroup.remove();
        this.signalStrengthAnalysisLegend.remove();
      }
    });

    effect(() => {
      if (this.mapStore.historicAnimalLocationLayer()) {
        mapContainer?.addLayer(this.historicAnimalLayerGroup);
      } else {
        this.historicAnimalLayerGroup.remove();
      }
    });

    effect(() => {
      if (this.mapStore.paddockLayer()) {
        mapContainer?.addLayer(this.paddockLayerGroup);
      } else {
        this.paddockLayerGroup.remove();
      }
    });

    effect(() => {
      if (this.mapStore.precipitationSamplePointLayer()) {
        mapContainer?.addLayer(this.precipitationSamplePointLayerGroup);
      } else {
        this.precipitationSamplePointLayerGroup.remove();
      }
    });

    effect(() => {
      if (this.mapStore.proximitySamplePointLayer()) {
        mapContainer?.addLayer(this.proximitySamplePointLayerGroup);
      } else {
        this.proximitySamplePointLayerGroup.remove();
      }
    });

    effect(() => {
      if (this.mapStore.waterPointLayer()) {
        mapContainer?.addLayer(this.waterPointLayerGroup);
      } else {
        this.waterPointLayerGroup.remove();
      }
    });

    effect(() => {
      const farm = this.farmStore.farm();
      if (!farm) return;

      this.mapStateService.resetShouldZoomToBounds();
      this.initMap(farm.location!);
      arcGisMaps.options.maxNativeZoom = farm.maxZoomLevel || defaultmaxNativeZoom;
    });

    effect(() => {
      this.signalStrenghtAnalysisLayer.setData(this.signalStrengthAnalysisStore.locations(), this.signalStrengthAnalysisStore.visibleGateway());
      this.signalStrenghtAnalysisLayer.render();
    });

    effect(() => {
      const paddockGeometries = this.farmStore.paddockGeometries();
      if (!paddockGeometries) return;

      this.paddockLayer.setPaddockGeometries(paddockGeometries);
      this.paddockLayer.render();
    });

    effect(() => {
      if (this.paddockStore.loading()) return;

      const paddocks = this.paddockStore.entities();
      this.paddockLayer.setPaddocks(paddocks);
      this.paddockLayer.render();
    });

    effect(() => {
      const locations = this.historicalLocationStore.filteredHistoricalLocations();
      console.log('[DEBUG map-container] filteredHistoricalLocations', locations);
      this.historicAnimalLayer.setLocations(locations);
      this.historicAnimalLayer.render(this.viewRef);
    });

    effect(() => {
      if (this.waterPointStore.loading()) return;

      const assetSamples = this.waterPointStore.assetSamples();
      this.waterPointLayer.setData(assetSamples);
      this.waterPointLayer.render(this.viewRef)
    });
  }

  private createUserMarker(viewRef: ViewContainerRef) {
    const userMarker = viewRef.createComponent(UserLocationMarkerComponent);
    const userMarkerHtml = userMarker.location.nativeElement.innerHTML;
    userMarker.destroy();

    const icon = new L.DivIcon({
      iconSize: [20, 20],
      className: "map-icon-label",
      html: userMarkerHtml
    });

    const latLng = new L.LatLng(0, 0, 0.5);

    return new L.Marker(latLng, {
      autoPan: false,
      icon: icon,
      opacity: 0
    });
  }

  ngOnInit(): void {
    this.dataSubscriptionService.onNext<boolean>('dropAPin').pipe(takeUntil(this.destroy$)).subscribe({
      next: dropAPin => {
        if (dropAPin) {
          this.mapStateService.activateDropAPin();
          this.dropAPinLayer.render(this.viewRef);
        } else {
          this.dropAPinLayer.clear();
          this.mapStateService.deactivateDropAPin();
        }
      }
    })

    this.dataSubscriptionService.onNext<Array<Samples.AssetSample<Samples.GPSFix>>>('grazingPatternSamples').pipe(takeUntil(this.destroy$)).subscribe({
      next: heatmapSamples => {
        this.grazingPatternLayer.setData(heatmapSamples);
        this.grazingPatternLayer.render();
      }
    })

    this.dataSubscriptionService.onNext<Map<FixedSamplePoint, Array<Samples.AssetSample<Samples.PrecipitationSample>>>>('precipitationPointAssetSamples').pipe(takeUntil(this.destroy$)).subscribe({
      next: precipitationPointAssetSamples => {
        this.precipitationSamplePointLayer.setData(precipitationPointAssetSamples);
        this.precipitationSamplePointLayer.render(this.viewRef);
      }
    })

    this.dataSubscriptionService.onNext<string>('resetView')
      .subscribe({
        next: _ => {
          const farm = this.farmStore.farm();
          if (!farm) return;

          const farmCoordinates = farm.location
          mapContainer?.setView(
            {
              lat: farmCoordinates.coords![0],
              lng: farmCoordinates.coords![1]
            }, mapContainer.getZoom(), {
              animate: true,
              easeLinearity: 1
            }
          );
        }
      });
  }

  initMap(farmCoordinates: Samples.Position) {
    if (mapContainer) {
      mapContainer?.remove()
      mapContainer = undefined;
      this.initMap(farmCoordinates)
    } else {
      mapContainer = L.map('map', {
        zoomControl: false,
        renderer: L.canvas({padding: 0.5, tolerance: 0.1}),
        zoom: baseZoom,
        minZoom: minZoom,
        maxZoom: maxZoom,
        trackResize: true,
        attributionControl: false,
        zoomAnimation: true,
        markerZoomAnimation: true,
        maxBounds: [
          [-85, -180], // Southwest corner
          [85, 180]    // Northeast corner
        ],
        maxBoundsViscosity: 1.0,
        fadeAnimation: true,
        layers: [
          arcGisMaps,
          this.waterPointLayerGroup,
          this.animalLayerGroup,
          this.gatewayLayerGroup,
          this.proximitySamplePointLayerGroup,
          this.paddockLayerGroup,
          this.precipitationSamplePointLayerGroup,
          this.userMarker
        ]
      }).setView({lat: farmCoordinates.coords![0], lng: farmCoordinates.coords![1]})

      L.control.scale({position: "bottomright"}).addTo(mapContainer!);

      const tiles = {
        "ArcGIS": arcGisMaps,
        "OpenStreetMap": openStreetMaps
      };
      const overlays = {
        "Water points": this.waterPointLayerGroup,
        "Animals": this.animalLayerGroup,
        "Gateways": this.gatewayLayerGroup,
        "Proximity-sample points": this.proximitySamplePointLayerGroup,
        "Paddocks": this.paddockLayerGroup,
        "Precipitation-sample points": this.precipitationSamplePointLayerGroup
      };
      const layerControl = L.control.layers(tiles, overlays, {position: "bottomright"});
      mapContainer.addControl(layerControl);

      this.invalidateSize()
    }
    this.mapStore.setInitializedMap(true);
  }

  ngOnDestroy(): void {
    mapContainer?.remove()
    mapContainer = undefined;
    this.destroy$.next()
    this.destroy$.complete()
  }

  private invalidateSize() {
    setTimeout(() => {
      mapContainer?.invalidateSize();
    }, 400);
  }
}

@Injectable({providedIn: 'root'})
export class MapStateService {
  protected activeLocator?: L.Marker
  protected markedAssets: Map<Asset, L.Marker> = new Map<Asset, L.Marker>()
  protected destroy$: Subject<void> = new Subject<void>();

  private dropAPinActive = false;
  private shouldZoomToBounds = true;

  private readonly mainViewStore = inject(MainViewStore);
  private readonly mapStore = inject(MapStore);
  private readonly router = inject(Router);
  protected dataSubscriptionService = inject(DataSubscriptionService);
  protected viewportService = inject(ViewportService);

  activateDropAPin() {
    this.dropAPinActive = true;
  }

  deactivateDropAPin() {
    this.dropAPinActive = false;
  }

  isDropAPinActive(): boolean {
    return this.dropAPinActive;
  }

  subscribeForLocatorEvents<A extends Asset>(marker: L.Marker, viewRef: ViewContainerRef, asset: A, iconPath: string = `asset-markers/generic-locator.svg`, iconAnchor: L.PointExpression) {
    this.dataSubscriptionService.onChanges<string>(asset.id + '.focus').pipe(takeUntil(this.destroy$)).subscribe({
      next: _ => {
        if (this.dropAPinActive) return;

        const latLng = marker.getLatLng();
        this.centerPanLeaflet(latLng);
        this.removeLocator();
        this.addLocator(latLng, viewRef, iconPath, iconAnchor);
      }
    })
  }

  destroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  resetShouldZoomToBounds() {
    this.shouldZoomToBounds = true;
  }

  zoomToBounds(bounds: L.FeatureGroup) {
    if (!this.shouldZoomToBounds) return;

    const latLngBounds = bounds.getBounds()
    if (mapContainer && latLngBounds && latLngBounds.isValid()) {
      mapContainer.fitBounds(latLngBounds);
      this.shouldZoomToBounds = false;
    }
  }

  centerPan(latitude: number, longitude: number) {
    const latLng = new L.LatLng(latitude, longitude);
    this.centerPanLeaflet(latLng);
  }

  centerPanLeaflet(latLng: L.LatLng) {

    if (!mapContainer) return;

    // To ensure smooth usage, the leaflet map is always present on one of the lower z-indices and always the same size.
    // However, panning to an asset always uses the center of the full map. So we use these corrections to actually show
    // the asset in the center of the part of the map that is visible.

    if (this.viewportService.isLargeViewPort()) {
      const offsetPoint = mapContainer!.latLngToContainerPoint(latLng).subtract([200, 0]);
      const correctedLatLng = mapContainer!.containerPointToLatLng(offsetPoint);
      mapContainer!.panTo(correctedLatLng);
    } else {
      const mapSize = mapContainer!.getSize();
      const offsetY = (mapSize.y * -0.55) / 2;
      const offsetPoint = mapContainer!.latLngToContainerPoint(latLng).subtract([0, offsetY]);
      const correctedLatLng = mapContainer!.containerPointToLatLng(offsetPoint);
      mapContainer!.panTo(correctedLatLng);
    }
  }

  center(marker: L.Marker) {
    const latLng = marker.getLatLng()
    mapContainer?.setView(latLng);
  }

  subscribeForClickEvents(url: string, marker: L.Marker, asset: Asset) {
    marker.on('click', _ => {
      if (this.dropAPinActive) return;

      this.mainViewStore.showChildComponent();
      this.mapStore.resetLayers();
      this.router.navigate([url, asset.id]);
    })
  }

  removeLocator() {
    if (this.activeLocator && mapContainer) {
      this.activeLocator.remove()
      this.activeLocator = undefined
    }
  }

  addLocator(latLng: L.LatLng, viewRef: ViewContainerRef, iconPath: string, iconAnchor: L.PointExpression) {
    const locatorMarker = viewRef.createComponent(LocatorMarkerComponent)
    locatorMarker.instance.icon = iconPath
    locatorMarker.hostView.detectChanges()
    const locatorMarkerHtml = locatorMarker.location.nativeElement.innerHTML
    locatorMarker.destroy()

    const icon = new L.DivIcon({
      iconSize: [60, 60],
      className: "map-icon-label",
      html: locatorMarkerHtml,
      iconAnchor: iconAnchor
    })
    const locator = new L.Marker(latLng, {
      icon: icon,
      autoPan: false,
    })
    this.activeLocator = locator
    if (mapContainer) locator.addTo(mapContainer)

    return locator;
  }

  moveLocator(lat: number, long: number) {
    const latLong = new L.LatLng(lat, long);
    this.moveLocatorLeaflet(latLong);
  }

  moveLocatorLeaflet(latLng: L.LatLng) {
    this.activeLocator?.setLatLng(latLng)
  }
}

class SignalStrengthAnalysisLegend extends L.Control {
  override onAdd(_map: L.Map): HTMLElement {
    const div = L.DomUtil.create('div', 'signal-strength-analysis-legend');
    div.innerHTML = `
      <div class="rssi-text">
        <span class="rssi-title">Signal strength per location (dB)</span>
        <span class="rssi-info">Bright red spots indicate areas that may have poor coverage.</span>
      </div>
      <div class="rssi-distribution">
        <div class="rssi-values">
          <span>-60</span>
          <span>-140</span>
        </div>
        <img src="rssi-gradient.png" />
      </div>
    `;

    return div;
  }
}

abstract class MapLayer {

  protected layerGroup?: L.LayerGroup;
  protected dataSubscriptionService = inject(DataSubscriptionService);
  protected deviceAssociationStore = inject(DeviceAssociationStore);
  protected deviceStore = inject(DeviceStore);
  protected viewportService = inject(ViewportService);
  protected mapStateService = inject(MapStateService);

  setLayerGroup(layerGroup: L.LayerGroup) {
    this.layerGroup = layerGroup;
  }

  abstract render(viewRef: ViewContainerRef): void
}

@Injectable({providedIn: 'root'})
class DropAPinLayer extends MapLayer {

  override render(viewRef: ViewContainerRef): void {
    this.clear()
    setTimeout(() => {
      const locator = this.mapStateService.addLocator(mapContainer!.getCenter(), viewRef, `asset-markers/generic-locator.svg`, [20, 40]);
      locator.on('click', e => {
        const latLng = locator.getLatLng();
        this.dataSubscriptionService.publish('currentPosition', {lng: latLng.lng, lat: latLng.lat});
        locator.removeEventListener('click')
      });
    }, 100)
    // Move the crosshair to the center of the map when the user pans
    mapContainer!.on('move', () => {
      const center = mapContainer!.getCenter();
      if (center) this.mapStateService.moveLocatorLeaflet(center);
    });
  }

  clear() {
    mapContainer?.removeEventListener('move')
    this.mapStateService.removeLocator();
  }
}

@Injectable({providedIn: 'root'})
class AnimalLayer extends MapLayer {

  private animals?: Animal[];
  private aggregatedAssetStates?: EntityMap<AggregatedAssetState>;
  private period?: LocationAgeFilterPeriod;

  private unclickableIcon = new L.DivIcon({
    iconSize: [0, 0]
  });

  setData(animals?: Animal[], aggregatedAssetStates?: EntityMap<AggregatedAssetState>, period?: LocationAgeFilterPeriod) {
    this.animals = animals;
    this.aggregatedAssetStates = aggregatedAssetStates;
    this.period = period;
  }

  override render(viewRef: ViewContainerRef): void {
    this.layerGroup?.clearLayers();

    const markerCluster = new L.MarkerClusterGroup({
      maxClusterRadius: 20,
      spiderfyDistanceMultiplier: 4,
      spiderfyOnMaxZoom: true,
      spiderLegPolylineOptions: {
        fillColor: 'white'
      },
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
    });

    let icon: L.DivIcon;
    markerCluster.on('spiderfied', event => {
      icon = event.cluster.getIcon();
      event.cluster.setIcon(this.unclickableIcon);
    });
    markerCluster.on('unspiderfied', event => {
      event.cluster.setIcon(icon);
      this.mapStateService.removeLocator();
    });

    if (!this.animals || !this.aggregatedAssetStates) return;

    const threeDaysAgo = (new Date().getTime() - threeDays);
    const threshold = this.threshold();

    this.animals.forEach((animal) => {
      const state = this.aggregatedAssetStates![animal.id];
      if (!state) return;

      const position = state.position;
      if (!position) return;

      if (!position[0] || !position[1]) return;

      const warning = state.outOfPaddockSince !== undefined || state.stoppedMovingSince !== undefined || state.abnormalActivitySince !== undefined ||
        (state.lastGPSFixAt === undefined && state.lastSeenByBLEScannerAt === undefined) ||
        (state.lastGPSFixAt !== undefined && state.lastGPSFixAt.getTime() < threeDaysAgo) ||
        (state.lastSeenByBLEScannerAt !== undefined && state.lastSeenByBLEScannerAt.getTime() < threeDaysAgo);
      const visible = this.seenWithinThreshold(state, threshold);

      const latLng = new L.LatLng(position[0], position[1], 0.5)
      const isNfcRelatedAnimal = this.hasNfcTag(animal);
      const marker = this.createAnimalMarkerIcon(animal, isNfcRelatedAnimal, warning, visible, latLng, viewRef);

      if (visible) {
        markerCluster.addLayer(marker)
      } else {
        this.layerGroup?.addLayer(marker);
      }
    });
    this.layerGroup?.addLayer(markerCluster)
  }

  private seenWithinThreshold(state: AggregatedAssetState, threshold?: Date) {
    if (!threshold) return true;

    return (state.lastGPSFixAt !== undefined && state.lastGPSFixAt >= threshold)
      || (state.lastSeenByBLEScannerAt !== undefined && state.lastSeenByBLEScannerAt >= threshold)
      || (state.lastNfcGpsFixAt !== undefined && state.lastNfcGpsFixAt >= threshold);
  }

  private threshold() {
    if (!this.period) return undefined;

    switch (this.period) {
      case LocationAgeFilterPeriod.ALL: return undefined;
      case LocationAgeFilterPeriod.LAST_24_HOURS: return new Date(new Date().getTime() - twentyFourHours);
      case LocationAgeFilterPeriod.LAST_3_DAYS: return new Date(new Date().getTime() - threeDays);
      case LocationAgeFilterPeriod.LAST_7_DAYS: return new Date(new Date().getTime() - sevenDays);
      case LocationAgeFilterPeriod.LAST_30_DAYS: return new Date(new Date().getTime() - thirtyDays);
      case LocationAgeFilterPeriod.LAST_60_DAYS: return new Date(new Date().getTime() - sixtyDays);
    }
  }

  private createAnimalMarkerIcon(animal: Animal, isNfcRelatedAnimal: boolean, warning: boolean, visible: boolean, latLng: L.LatLng, viewRef: ViewContainerRef): L.Marker {
    const animalMarker = viewRef.createComponent(AnimalMarkerComponent)
    animalMarker.instance.animalType = animal.type
    const width = isNfcRelatedAnimal ? 40 : 20
    const height = isNfcRelatedAnimal ? 40 : 20
    animalMarker.instance.width = width.toString()
    animalMarker.instance.height = height.toString()
    animalMarker.instance.hasWarning = warning
    animalMarker.instance.name = animal.visualTag
    animalMarker.hostView.detectChanges()
    const animalMarkerHtml = animalMarker.location.nativeElement.innerHTML
    animalMarker.destroy()

    const icon = new L.DivIcon({
      iconSize: [width, height],
      className: "map-icon-label",
      html: animalMarkerHtml
    })
    const marker = new L.Marker(latLng, {
      icon: icon,
      autoPan: false,
      opacity: visible ? 1 : 0,
      interactive: visible
    })
    if (visible) this.mapStateService.subscribeForClickEvents('main/animal-details', marker, animal)
    this.mapStateService.subscribeForLocatorEvents(marker, viewRef, animal, `animal-markers/${simplify(animal.type as AnimalType)}-locator.svg`, [25, 60])
    return marker
  }

  protected hasNfcTag(animal: Animal): boolean {
    const assetId = animal.id;
    const deviceAssociations = this.deviceAssociationStore.assetIdToAssocations().get(assetId)
    const deviceId = deviceAssociations?.at(0)?.deviceId;
    if (deviceId == undefined) return false;
    const deviceType = this.deviceStore.deviceIdToType().get(deviceId!);
    return deviceType === DeviceType.NFC_TAG;
  }
}

@Injectable({providedIn: 'root'})
class HistoricAnimalLocationLayer extends MapLayer {

  private locations?: HistoricalLocation[];

  setLocations(locations: HistoricalLocation[]) {
    this.locations = locations;
  }

  render(viewRef: ViewContainerRef): void {
    this.layerGroup?.clearLayers();

    if (!this.locations || this.locations.length === 0) return;

    const markerCluster = new L.MarkerClusterGroup({
      maxClusterRadius: 20,
      spiderfyDistanceMultiplier: 3,
      spiderfyOnMaxZoom: true,
      spiderLegPolylineOptions: {
        fillColor: 'white'
      },
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
    });

    const lineCoordinates = this.connectPoints(this.locations);
    this.layerGroup?.addLayer(L.polyline(lineCoordinates, {color: "#00047A"}));

    const maxIndex = this.locations.length - 1
    this.locations.forEach((location, index) => {
      const coords = location.coords;
      const latLng = new L.LatLng(coords[0], coords[1], 0.5);
      const marker = this.createAnimalMarkerIcon(location, index, maxIndex, latLng, viewRef);
      marker.addTo(markerCluster);
    });
    this.layerGroup?.addLayer(markerCluster);
  }

  private connectPoints(locations: HistoricalLocation[]) {
    const lineCoordinates: Array<L.LatLng> = [];
    locations.forEach((location) => {
      const x = location.coords[0];
      const y = location.coords[1];
      lineCoordinates.push(new L.LatLng(x, y, 0.5));
    })
    return lineCoordinates;
  }

  private createAnimalMarkerIcon(location: HistoricalLocation, index: number, maxIndex: number, latLng: L.LatLng, viewRef: ViewContainerRef): L.Marker {
    const animalMarker = viewRef.createComponent(AnimalMarkerComponent)
    const date = new Date(location.instant)
    animalMarker.instance.name = timeAgo(date)
    animalMarker.instance.hasWarning = !!location.alertStatus
    animalMarker.hostView.detectChanges()
    const animalMarkerHtml = animalMarker.location.nativeElement.innerHTML
    animalMarker.destroy()
    const icon = new L.DivIcon({
      iconSize: [20, 20],
      className: "map-icon-label",
      html: animalMarkerHtml
    })
    const title = this.toTitle(location);
    return new L.Marker(latLng, {
      icon: icon,
      opacity: 1 - ((index / maxIndex) / 2),
      autoPan: false,
      title
    });
  }

  private toTitle(location: HistoricalLocation): string {
    const status = location.alertStatus;
    const source = location.source || "LOCATION_SAMPLE";

    return [source, status]
      .filter(s => !!s)
      .join(" - ");
  }
}

@Injectable({providedIn: 'root'})
class GatewayLayer extends MapLayer {

  private gateways?: LoRaGateway[];
  private statuses?: EntityMap<LoRaGatewayStatus>;
  private readonly toGatewayIconPipe = inject(ToGatewayIconPipe);

  setStatuses(statuses: EntityMap<LoRaGatewayStatus>) {
    this.statuses = statuses;
  }

  setGateways(gateways: LoRaGateway[]) {
    this.gateways = gateways;
  }

  render(viewRef: ViewContainerRef): void {
    this.layerGroup?.clearLayers();

    if (!this.statuses) return;

    if (!this.gateways || this.gateways.length === 0) return;

    for (const gateway of this.gateways) {
      const location = gateway.location;
      if (!location) continue;

      const coords = location.coords;
      if (!coords?.[0] || !coords[1]) continue;

      const status = this.statuses[gateway.id]?.normalisedValue;
      const latLng = new L.LatLng(coords[0], coords[1], 0.5);
      const iconName = this.toGatewayIconPipe.transform(status);
      const marker = this.createGatewayIcon(latLng, viewRef, iconName, status);
      this.layerGroup?.addLayer(marker);
      const radius = L.circle(latLng, {radius: 4000, color: '#000000', fill: false, weight: 1, interactive: false});
      this.layerGroup?.addLayer(radius);
      this.mapStateService.subscribeForClickEvents('main/gateway-details', marker, gateway);
      this.mapStateService.subscribeForLocatorEvents(marker, viewRef, gateway, undefined, [18, 62]);
    };
  }

  private createGatewayIcon(latLng: L.LatLng, viewRef: ViewContainerRef, iconName: string, status?: string): L.Marker {
    const gatewayMarkerComponentRef = viewRef.createComponent(GatewayMarkerComponent)
    gatewayMarkerComponentRef.instance.iconName = iconName
    gatewayMarkerComponentRef.instance.status = status
    gatewayMarkerComponentRef.hostView.detectChanges()
    const gatewayMarkerHtml = gatewayMarkerComponentRef.location.nativeElement.innerHTML
    gatewayMarkerComponentRef.destroy()
    const icon = new L.DivIcon({
      iconSize: [20, 20],
      className: "map-icon-label",
      html: gatewayMarkerHtml
    })
    return new L.Marker(latLng, {
      icon: icon,
      autoPan: false,
    })
  }
}

@Injectable({providedIn: 'root'})
class ProximitySamplePointLayer extends MapLayer {

  private proximitySamplePoints?: FixedSamplePoint[];
  private aggregatedAssetStates?: EntityMap<AggregatedAssetState>;

  setProximitySamplePoints(proximitySamplePoints: FixedSamplePoint[]) {
    this.proximitySamplePoints = proximitySamplePoints;
  }

  setAggregatedAssetStates(aggregatedAssetStates: EntityMap<AggregatedAssetState>) {
    this.aggregatedAssetStates = aggregatedAssetStates;
  }

  render(viewRef: ViewContainerRef): void {
    this.layerGroup?.clearLayers();

    if (!this.proximitySamplePoints || this.proximitySamplePoints.length === 0) return;

    this.proximitySamplePoints.forEach((proximitySamplePoint) => {
      const location = this.location(proximitySamplePoint);
      if (!location?.[0] || !location[1]) return;

      const latLng = new L.LatLng(location[0], location[1])
      const iconName = "icons/bluetooth-icon-color.svg"
      const isOnline = this.lastSeenWithinThreshold(proximitySamplePoint);

      const marker = this.createUpdateProximityPointIcon(latLng, viewRef, iconName, isOnline)
      this.layerGroup?.addLayer(marker)

      const radius = L.circle(latLng, {radius: 25, color: isOnline ? '#0076f7' : '#FF401F', fill: false, weight: 1, interactive: false})
      this.layerGroup?.addLayer(radius)

      this.mapStateService.subscribeForClickEvents('main/proximity-sample-point-details', marker, proximitySamplePoint)
      this.mapStateService.subscribeForLocatorEvents(marker, viewRef, proximitySamplePoint, undefined, [25, 68])
    });
  }

  private location(proximitySamplePoint: FixedSamplePoint): number[] | undefined {
    if (proximitySamplePoint.sampleBasedLocation) {
      if (!this.aggregatedAssetStates) return undefined;

      const aggregatedState = this.aggregatedAssetStates[proximitySamplePoint.id];
      return aggregatedState?.position;
    } else {
      return proximitySamplePoint.location?.coords;
    }
  }

  private lastSeenWithinThreshold(proximitySamplePoint: FixedSamplePoint) {
    if (!this.aggregatedAssetStates) return false;

    const aggregatedState = this.aggregatedAssetStates[proximitySamplePoint.id];
    const lastSeenByGatewayAt = aggregatedState?.lastSeenByGatewayAt;

    if (!lastSeenByGatewayAt) return false;

    return isEqualToOrYoungerThanOffset(lastSeenByGatewayAt, oneHour);
  }

  private createUpdateProximityPointIcon(latLng: L.LatLng, viewRef: ViewContainerRef, iconName: string, online: boolean): L.Marker {
    const proximitySamplePointsComponentComponentRef = viewRef.createComponent(ProximityPointMarkerComponent)
    proximitySamplePointsComponentComponentRef.setInput('iconName', iconName);
    proximitySamplePointsComponentComponentRef.setInput('status', online ? Status.ONLINE : Status.OFFLINE);
    proximitySamplePointsComponentComponentRef.hostView.detectChanges()
    const html = proximitySamplePointsComponentComponentRef.location.nativeElement.innerHTML
    proximitySamplePointsComponentComponentRef.destroy()

    const icon = new L.DivIcon({
      iconSize: [32, 23],
      className: "map-icon-label",
      html: html,
      iconAnchor: [16, 16]
    })
    return new L.Marker(latLng, {
      icon: icon,
      autoPan: false
    })
  }
}

@Injectable({providedIn: 'root'})
class GrazingPatternLayer extends MapLayer {

  private data?: Samples.AssetSample<Samples.GPSFix>[];

  setData(data: Samples.AssetSample<Samples.GPSFix>[]) {
    this.data = data;
  }

  render(): void {
    this.layerGroup?.clearLayers();

    if (!this.data || this.data.length === 0) return;

    const heatmapData: Array<L.LatLng> = this.data
      .filter(sample => isValidGpsFixSample(sample))
      .map(assetSample => new L.LatLng(assetSample.sample.value.position!.coords![0], assetSample.sample.value.position!.coords![1], 0.5));
    const coordinates = this.data.map(it => it.sample.value.position!.coords!)
    mapContainer!.setView([coordinates[0][0], coordinates[0][1]], 13);
    const heatLayer = L.heatLayer(heatmapData, {
      radius: 12,
      blur: 15,
      maxZoom: baseZoom
    });

    this.layerGroup?.addLayer(heatLayer);
  }
}

@Injectable({providedIn: 'root'})
class SignalStrengthAnalysisLayer extends MapLayer {

  private locations: Location[] = [];
  private visibleGateway?: string;

  setData(locations: Location[], visibleGateway?: string) {
    this.locations = locations;
    this.visibleGateway = visibleGateway;
  }

  render(): void {
    this.layerGroup?.clearLayers();

    if (!this.locations || this.locations.length === 0) return;

    this.locations.forEach(location => {
      if (this.visibleGateway && !location.rssiPerGateway[this.visibleGateway]) return;

      const coords = location.position.coords;
      this.layerGroup?.addLayer(L.circle(new L.LatLng(coords[0], coords[1]), {
        color: rssisToRgb(location.rssiPerGateway),
        fill: true,
        fillOpacity: 1,
        radius: 20,
        stroke: false,
        interactive: false
      }));
    });
  }
}

@Injectable({providedIn: 'root'})
class PaddockLayer extends MapLayer {

  private paddocks?: Paddock[];
  private paddockGeometries?: Map<string, PaddockGeometry>;

  private farmStore = inject(FarmStore);
  private paddocksStore = inject(PaddockStore);
  private router = inject(Router);

  setPaddocks(paddocks: Paddock[]) {
    this.paddocks = paddocks;
  }

  setPaddockGeometries(paddockGeometries: Map<string, PaddockGeometry>) {
    this.paddockGeometries = paddockGeometries;
  }

  render(): void {
    this.layerGroup?.clearLayers();

    if (!this.paddocks || this.paddocks.length === 0 || !this.paddockGeometries) return;

    const polygons: L.Layer[] = [];

    for (const paddock of this.paddocks) {
      if (paddock === unassignedAnimalsPaddock) return;

      const rings: L.LatLng[] = []
      const subset = paddock.boundaries!.rings![0]
      for (let i = 0; i < subset.length; i += 2) {
        const lat = subset[i]
        const lng = subset[i + 1]
        rings.push(new L.LatLng(lat, lng, 0.5))
      }
      const polygon = L.polygon(rings, {
        weight: 2,
        color: 'rgb(29,202,87)'
      })
      this.layerGroup?.addLayer(polygon);

      polygons.push(polygon)
      this.configureClickEvents(polygon, paddock, this.paddockGeometries);
    }
    const bounds = L.featureGroup(polygons)
    this.mapStateService.zoomToBounds(bounds);
  }

  private configureClickEvents(polygon: L.Polygon, paddock: Paddock, paddockGeometries: Map<string, PaddockGeometry>) {
    polygon.on('click', lme => {
      if (this.mapStateService.isDropAPinActive()) return;

      if (polygon.options.color !== 'rgb(29,202,87)') return;

      polygon.options.color = 'rgb(29,156,202)';
      polygon.redraw();

      this.paddocksStore.setSelectedPaddock(paddock);

      const countryCode = this.farmStore.farm()?.address.countryCode;
      const area = areaWithUnit(paddockGeometries.get(paddock.id)?.area, countryCode);

      L.popup({
        autoPan: false
      })
        .setLatLng(lme.latlng)
        .setContent(`
          <div style="font-weight: bold">${paddock.name}</div>
          <div>${area || ''}</div>
        `)
        .addEventListener('remove', () => {
          polygon.options.color = 'rgb(29,202,87)';
          polygon.redraw();
          this.paddocksStore.setSelectedPaddock(undefined);
        })
        .openOn(mapContainer!);

      this.router.navigate(['/main/animals']);
    });
  }
}

@Injectable({providedIn: 'root'})
export class PrecipitationSamplePointLayer extends MapLayer {

  private data?: Map<FixedSamplePoint, Array<Samples.AssetSample<Samples.PrecipitationSample>>>;

  setData(data: Map<FixedSamplePoint, Array<Samples.AssetSample<Samples.PrecipitationSample>>>) {
    this.data = data;
  }

  render(viewRef: ViewContainerRef): void {
    this.layerGroup?.clearLayers();

    if (!this.data || this.data.size == 0) return;

    this.data.forEach((_, precipitationSamplePoint) => {
      const location = precipitationSamplePoint.location
      if (!location) return;

      const coords = location.coords;
      if (!coords?.[0] || !coords[1]) return;

      const latLng = new L.LatLng(coords[0], coords[1], 0.5);
      const marker = this.createPrecipitationMarker(latLng, precipitationSamplePoint, viewRef);
      this.mapStateService.subscribeForClickEvents('main/precipitation-sample-point-details', marker, precipitationSamplePoint);
      this.mapStateService.subscribeForLocatorEvents(marker, viewRef, precipitationSamplePoint, undefined, [25, 68]);
      this.layerGroup?.addLayer(marker);
    })
  }

  private createPrecipitationMarker(latLng: L.LatLng, fixedAsset: FixedSamplePoint, viewRef: ViewContainerRef): L.Marker {
    const precipitationPointMarker = viewRef.createComponent(PrecipitationPointMarkerComponent)
    precipitationPointMarker.instance.name = fixedAsset.name!
    precipitationPointMarker.instance.iconName = "icons/precipitation-point-icon-color.svg"
    precipitationPointMarker.instance.precipitationPoint = fixedAsset
    precipitationPointMarker.hostView.detectChanges()
    const html = precipitationPointMarker.location.nativeElement.innerHTML
    precipitationPointMarker.destroy()
    const icon = new L.DivIcon({
      iconSize: [35, 35],
      className: "map-icon-label",
      html: html
    })
    return new L.Marker(latLng, {
      icon: icon,
      autoPan: false,
    })
  }
}

@Injectable({providedIn: 'root'})
class WaterPointLayer extends MapLayer {

  private data?: Map<WaterPoint, Array<Samples.AssetSample<any>>>;
  private readonly toWaterPointIconPipe = inject(ToWaterPointIconPipe);

  setData(data: Map<WaterPoint, Array<Samples.AssetSample<any>>>) {
    this.data = data;
  }

  render(viewRef: ViewContainerRef): void {
    this.layerGroup?.clearLayers();

    if (!this.data || this.data.size === 0) return;

    this.data.forEach((assetSamples, waterSamplePoint) => {
      const location = waterSamplePoint.location;
      if (!location) return;

      const coords = location.coords;
      if (!coords?.[0] || !coords[1]) return;

      const marker = this.createWaterPointIcon(waterSamplePoint.name, coords, assetSamples, viewRef)
      this.mapStateService.subscribeForClickEvents('main/water-point-details', marker, waterSamplePoint)
      this.mapStateService.subscribeForLocatorEvents(marker, viewRef, waterSamplePoint, undefined, [25, 68])
      this.layerGroup?.addLayer(marker)
    })
  }

  private createWaterPointIcon(name: string | undefined, coords: number[], assetSamples: Array<Samples.AssetSample<number>>, viewRef: ViewContainerRef) {
    const latLng = new L.LatLng(coords[0], coords[1], 0.5);
    const assetSample = assetSamples[0]
    const iconName = this.toWaterPointIconPipe.transform(assetSample?.alertStatus)
    const waterLevelMarker = viewRef.createComponent(WaterLevelMarkerComponent)
    waterLevelMarker.instance.name = name || '';
    const normalizedValue = (assetSample?.sample?.value || 0).toFixed()
    waterLevelMarker.instance.percentage = `${normalizedValue}%`
    waterLevelMarker.instance.iconName = iconName
    waterLevelMarker.instance.lastAssetSample = assetSample
    waterLevelMarker.hostView.detectChanges()
    const html = waterLevelMarker.location.nativeElement.innerHTML
    waterLevelMarker.destroy()
    const icon = new L.DivIcon({
      iconSize: [35, 35],
      className: "mapContainer-icon-label",
      html: html
    })
    return new L.Marker(latLng, {
      icon: icon,
      autoPan: false,
    })
  }

}
